import { memberDetailsQuery } from '@/queries/memberDetails.queries';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useMemberDetails = () => {
  const memberDetailsQueryResult = useQuery({
    ...memberDetailsQuery(),
    refetchInterval: 120 * 1000,
  });

  const { data: memberDetails } = memberDetailsQueryResult;

  useEffect(() => {
    if (
      memberDetails == null &&
      memberDetailsQueryResult.isFetching === false &&
      memberDetailsQueryResult.failureCount < 3
    ) {
      memberDetailsQueryResult.refetch();
    }
  }, [memberDetailsQueryResult, memberDetails]);

  return {
    memberDetailsQueryResult,
    memberDetails,
  };
};

export default useMemberDetails;
